import { getPercentage } from "@domains/utils/percentageFinder";
import { EOptionDrivingMarketSectionType, optionDrivingMarketLimit, } from "../entites/drivingMarket";
import { convertEPochToDate, } from "@domains/utils/stringMethods";
import { createDisplayName } from "../../../../utils/displayName";
export const optionDrivingMarketMapper = (data, dataType, viewAll) => {
    if (data) {
        const mapperData = {
            call: dataMapper(data.ceQt ? data.ceQt : [], viewAll, dataType),
            put: dataMapper(data.peQt ? data.peQt : [], viewAll, dataType),
            latestUpdatedTime: convertEPochToDate(data.lut),
        };
        return mapperData;
    }
    else {
        return {
            call: [],
            put: [],
            latestUpdatedTime: "",
        };
    }
};
function dataMapper(data, viewAll, dataType) {
    const result = viewAll ? data : data.slice(0, optionDrivingMarketLimit);
    const finalResult = [];
    result.map((item, i) => {
        let res = {
            change: item.chg,
            changePercentage: item.chgP,
            openInterest: item.oi,
            openInterestChange: item.oichg,
            oiChangePercentage: item.oichgP,
            displayName: item.dpName,
            latestTradingPrice: item.ltp,
            expiryDate: item.expDt,
            tradeSymbol: item.tsym,
            symbol: item.sym,
            companyName: item.cname,
            volume: item.vol,
            volumeChange: item.volChg,
            volumeChangePercentage: item.volChgP,
            barPercentage: calculateBarPercentage(result[0], item, dataType),
            dpExpDt: item.dpExpDt,
            stkPrc: item.stkPrc,
            opTyp: item.opTyp,
            asTyp: item.asTyp,
            // dispName: item.dpName + " " + item.dpExpDt?.split("'")[0] + " " + item.opTyp + " " + item.stkPrc
            dispName: createDisplayName(item),
        };
        finalResult.push(res);
    });
    return finalResult;
}
function calculateBarPercentage(base, data, dataType) {
    switch (dataType) {
        case EOptionDrivingMarketSectionType.HIGHEST_OI:
            return getPercentage(base.oi, data.oi);
        case EOptionDrivingMarketSectionType.HIGHEST_VOLUME:
            return getPercentage(base.vol, data.vol);
        case EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER:
            return getPercentage(base.oichgP, data.oichgP);
        case EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER:
            return getPercentage(base.oichgP, data.oichgP);
        default:
            return;
    }
}
